<template>
  <div>
    <div class="notification">
      <top-bar-button
          @button-click="handleOpenSideBar"
          style="cursor: pointer"
      />
      <chat-side-bar
          v-if="profile"
          :sb-model="ionaModel"
          :sb-id="ionaSBId"
          :profile="profile"
          comm-with="heartbeat"
          @close-clicked="handleSidebarClose"
      />
    </div>
  </div>
</template>
<script>
import TopBarButton from "./topBarButton";
import ChatSideBar from "@/components/common/chatSideBar";
import { mapGetters } from "vuex";
export default {
  name: "Communicate_Chat",
  components: {
    TopBarButton,
    ChatSideBar
  },
  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    serveNotificationsList() {
      return this.$store.getters["user/listNotifications"].filter(
        el => !el._answer
      );
    },
    count() {
      return this.serveNotificationsList.length;
    }
  },
  methods: {
    getProfile() {
      this.loading = true;
      this.$store.dispatch("user/getProfile", "").then(res => {
        this.loading = false;
      });
    },
    handleOpenSideBar() {
      //@ToDO- Use Ref
      this.ionaModel = true;
    },
    handleSidebarClose() {
      this.ionaModel = false;
    },
    handleNotifcationClick() {
      this.showModalNotifications = true;
    },
    handleResponseInvitation(resp, notif) {
      this.$store.dispatch("user/actionResponseInvitationJourney", {
        response: resp,
        notif
      });
      this.showModalNotifications = false;
    }
  },
  mounted() {
    //Get Messages and Threads
  },
  data() {
    return {
      ionaModel: false,
      ionaSBId: "IONA-chat",
      ionaConnection: {
        openAI: {
          key: "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",
          assistant: {
            assistant_id: "asst_7bRJ7rAix2ojty9R5mNqKZwN"
          }
        }
      },
      notificationPanel: false,
      showModalNotifications: true,
      mainProps: {
        blank: false,
        blankColor: "#fcc727",
        width: 50,
        height: 50,
        class: "m1"
      },
      mainPropsTopBar: {
        blank: false,
        blankColor: "#fcc727",
        width: 25,
        height: 25,
        class: "m1"
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(189, 189, 189, 0);
  z-index: 8;
}
.notification {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  span {
    cursor: pointer;
  }
  .red-dot {
    position: absolute;
    top: -6px;
    left: 50%;
  }

  .notifications-panel {
    z-index: 10;
    padding: 20px 10px;
    position: absolute;
    border-radius: 10px;
    width: 316px;
    top: 40px;
    right: -100px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0 #eee;
    div {
      margin: 0;
    }
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      /* identical to box height */

      /* Secondary */

      color: #8d99a0;
    }
    .see-all {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      /* identical to box height */

      /* Primary */

      color: var(--theme-color);
      text-decoration: none;
    }
    .noti-list {
      padding: 0 8px 24px 24px;
      max-height: 70vh;
      overflow-y: scroll;
      margin-right: 8px;
      &::-webkit-scrollbar {
        height: 0px;
        width: 8px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
        // width: 4px !important;
      }
      .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-green {
          background-color: #65ea82;
          max-width: 80%;
          margin-top: 12px;
          margin-bottom: 12px;
        }
      }
      .tool {
        position: relative;
        background: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-bottom: 8px;
        &.active {
          background: rgba(85, 126, 251, 0.1);
        }
        .ico {
          position: absolute;
          right: 18px;
          top: 22px;
        }
        .content__tool {
          cursor: pointer;
          padding: 18px;
          .info {
            display: grid;
            grid-template-columns: 32px 1fr;
            grid-column-gap: 14px;
            align-items: center;
            img {
              height: 32px;
              width: 32px;
            }
            h4 {
              margin: 0;
              font-weight: normal;
              font-size: 16px;
              line-height: 22px;
              color: #474d52;
            }
          }
        }
      }
    }
    .noti-msg {
      padding: 10px 0;
      border-top: 2px solid #d9d9d9;
      &.no-border {
        border: none;
      }
      display: grid;
      grid-template-columns: 45px 1fr;
      .name {
        font-size: 14px;
        line-height: 19px;
        font-weight: bold;
        color: #474d52;
      }
      .time {
        font-family: "Nunito", sans-serif;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
      .usr-msg {
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        /*margin-top: 6px;*/
      }
      .btn-fill,
      .btn-outline {
        /*margin-top: 12px;*/
        margin-left: 0;
        padding: 5px 15px;
        border-radius: 5px;
        text-decoration: none;
        font-weight: normal;
        font-size: 14px;
      }
      .btn-outline {
        border: none;
        &:hover {
          color: var(--theme-color);
        }
      }
      .btn-fill {
        &:hover {
          color: #fff;
        }
      }
      .usr-img {
        img {
          height: 40px;
          width: 40px;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .actions .accept {
        color: #fff;
      }
    }
  }
}
</style>
